<div class="manual-form-content flex h-full w-full flex-col bg-white px-10">
  <header class="flex shrink-0 items-center gap-2 border-b border-gray-200 px-4 py-3">
    <h2 class="text-lg font-semibold uppercase tracking-wide text-gray-800">Manual</h2>
  </header>
  <form
    autocomplete="new-password"
    class="flex flex-1 flex-col gap-4 overflow-y-auto px-1 py-12"
    [formGroup]="manualForm"
    (submit)="$event.preventDefault()"
  >
    <div class="manual-form-mrn-block">
      <div class="text-field-wrapper" [class.field-invalid]="showFieldError(manualForm.controls.mrn)">
        <label class="text-field-label" for="manual-mrn">
          MRN <span aria-hidden="true" class="manual-form-label-required">*</span>
        </label>
        <spri-mrn-search-select
          class="manual-form-mrn-input"
          formControlName="mrn"
          inputId="manual-mrn"
          [ariaDescribedBy]="showFieldError(manualForm.controls.mrn) ? 'manual-mrn-errors' : null"
          [ariaInvalid]="showFieldError(manualForm.controls.mrn)"
          [required]="true"
          [showLabel]="false"
          (blurRequest)="onMrnBlur()"
        />
        @if (showFieldError(manualForm.controls.mrn)) {
          <div class="field-errors" id="manual-mrn-errors" role="alert">
            @if (manualForm.controls.mrn.hasError('required')) {
              <span class="field-error" id="manual-mrn-error-required">MRN is required</span>
            }
            @if (manualForm.controls.mrn.hasError('minlength')) {
              <span class="field-error" id="manual-mrn-error-minlength">MRN must be at least 3 characters</span>
            }
            @if (manualForm.controls.mrn.hasError('maxlength')) {
              <span class="field-error" id="manual-mrn-error-maxlength">MRN must be at most 30 characters</span>
            }
            @if (manualForm.controls.mrn.hasError('pattern')) {
              <span class="field-error" id="manual-mrn-error-pattern">MRN must be alphanumeric</span>
            }
          </div>
        }
      </div>
    </div>
    <spri-form-field
      formControlName="joints"
      id="manual-joints"
      name="manualJoints"
      type="select"
      [label]="'Joints'"
      [options]="jointsOptions()"
      [required]="true"
    />
    <spri-form-field
      formControlName="category"
      id="manual-category"
      name="manualCategory"
      type="select"
      [label]="'Category'"
      [options]="categoryOptions()"
      [required]="true"
    />
    <spri-form-field
      formControlName="physician"
      id="manual-physician"
      name="manualPhysician"
      type="select"
      [label]="'Physician'"
      [options]="physicianOptions()"
      [required]="true"
    />
  </form>
  <footer class="flex shrink-0 justify-center gap-2 border-t border-gray-200 px-4 py-4"></footer>
</div>
